import { matchIsValidTel } from 'mui-tel-input';

export const validate = (field: string, value: FormDataEntryValue | null, code?: string): string => {
  let result = '';
  switch (field) {
    case 'email':
      if (!value) {
        result = 'Email is required!';
        return result;
      }
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(String(value))) {
        result = 'Invalid email address!';
        return result;
      }
      break;
    case 'password':
      if (!value) {
        result = 'Password is required!';
        return result;
      }
      if (!/^.{8,}$/.test(String(value))) {
        result = 'Password should be at least 8 characters long';
        return result;
      }
      if (!/^(?=.*[a-z]).+$/.test(String(value))) {
        result = 'Password should contain at least one lowercase letter';
        return result;
      }
      if (!/^(?=.*[A-Z]).+$/.test(String(value))) {
        result = 'Password should contain at least one uppercase letter';
        return result;
      }
      if (!/^(?=.*\d)[a-zA-Z\d]+$/.test(String(value))) {
        result = 'Password should contain at least one digit!';
        return result;
      }
      break;
    case 'code':
      if (!value) {
        result = 'Verification code is required!';
        return result;
      }
      if (!(/^[0-9][0-9][0-9][0-9][0-9][0-9]$/.test(String(value)))) {
        result = 'Verification code should be 6 digits long';
        return result;
      }
      break;
    default:
      return result;
  }
  return '';
};

export const validatePhoneNumber = (require: boolean) => (text: string): boolean => {
  if (require || (text && text.indexOf(' ') !== -1)) {
    return matchIsValidTel(text || '');
  }

  return true;
};
